// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-2eRv_RBS","breadcrumbs":"breadcrumbs-2VNazwM4"};